import React from 'react';
import findResult from '@/utils/resultsHelper';
import { readStates } from '@/constants/lifecycle';
import PanelContainer from '@/components/wrappers/PanelContainer';
import {
  fetchRole, updatePermissionsPanels, updateRoleFilter, updateRoleProperties,
} from '../actions';
import { rolePanels } from '../state/state';

const RolePanelContainer = ({
  canRead,
  children,
  exists,
  description,
  isDirty,
  name,
  onChange,
  readErrors,
  readStatus,
  url,
}) => (
  <PanelContainer
    canAccess={canRead}
    description={description}
    entity="role"
    exists={exists}
    isDirty={isDirty}
    name={name}
    onChange={onChange}
    readErrors={readErrors}
    readStatus={[readStatus]}
    url={url}
  >
    {children}
  </PanelContainer>
);

const accessControl = (role, exists, item = null) => (
  {
    exists,
    canRead: exists ? role.permissions.roles.read : false,
    canEdit: exists ? role.permissions.roles.update && !item.system : false,
  }
);

const withoutItem = (role) => (
  {
    ...accessControl(role, false),
    ...readStates,
    ...rolePanels(),
  }
);

const withItem = (item, role) => (
  {
    ...accessControl(role, true, item),
    role: item,
    isDirty: item.isDirty,
    readStatus: item.readStatus,
    readErrors: item.readErrors,
    updateStatus: item.updateStatus,
    updateErrors: item.updateErrors,
    name: item.name,
    description: item.description,
    filter: item.filter,
    panels: item.panels,
    grouping: item.grouping,
  }
);

export const mapStateToProps = ({
  auth: { role },
  roles: { roles },
}, { category, code }) => {
  const item = findResult(roles, category, code);
  return item ? withItem(item, role) : withoutItem(role);
};

export const mapDispatchToProps = {
  fetchData: fetchRole,
  updateProperties: updateRoleProperties,
  updateFilter: updateRoleFilter,
  updatePanels: updatePermissionsPanels,
};

export default RolePanelContainer;
